<template>
  <div class="pos-section">
    <div class="section-head">
      <span class="section-label">Vị trí chữ ký</span>
      <span class="section-hint">A4: 595x842 pt</span>
    </div>

    <div class="pos-grid">
      <div class="pos-field">
        <label>Trang</label>
        <input type="number" :value="value.page" min="1" @input="update('page', $event.target.value)">
      </div>
      <div class="pos-field">
        <label>X</label>
        <input type="number" :value="value.x" min="0" @input="update('x', $event.target.value)">
        <span class="unit">pt</span>
      </div>
      <div class="pos-field">
        <label>Y</label>
        <input type="number" :value="value.y" min="0" @input="update('y', $event.target.value)">
        <span class="unit">pt</span>
      </div>
      <div class="pos-field">
        <label>W</label>
        <input type="number" :value="value.width" min="10" @input="update('width', $event.target.value)">
        <span class="unit">pt</span>
      </div>
      <div class="pos-field">
        <label>H</label>
        <input type="number" :value="value.height" min="10" @input="update('height', $event.target.value)">
        <span class="unit">pt</span>
      </div>
    </div>

    <div class="presets">
      <button @click="applyPreset('bottom-right')">Dưới-Phải</button>
      <button @click="applyPreset('bottom-left')">Dưới-Trái</button>
      <button @click="applyPreset('top-right')">Trên-Phải</button>
    </div>
  </div>
</template>

<script>
var PRESETS = {
  'bottom-right': { x: 350, y: 50, width: 200, height: 80 },
  'bottom-left':  { x: 50,  y: 50, width: 200, height: 80 },
  'top-right':    { x: 350, y: 720, width: 200, height: 80 }
}

export default {
  name: 'SignaturePosition',
  props: {
    value: { type: Object, default: function() { return { x: 350, y: 50, page: 1, width: 200, height: 80 } } }
  },
  methods: {
    update(field, rawValue) {
      this.$emit('input', Object.assign({}, this.value, { [field]: parseInt(rawValue, 10) || 0 }))
    },
    applyPreset(name) {
      if (PRESETS[name]) {
        this.$emit('input', Object.assign({}, this.value, PRESETS[name]))
      }
    }
  }
}
</script>

<style scoped>
.section-head { display:flex; align-items:center; gap:8px; margin-bottom:10px; }
.section-label { font-size:13px; font-weight:600; color:#1e293b; }
.section-hint { font-size:11px; color:#94a3b8; font-family:'JetBrains Mono',monospace; }

.pos-grid {
  display:grid; grid-template-columns:repeat(5,1fr); gap:6px; margin-bottom:8px;
}
.pos-field { position:relative; }
.pos-field label {
  display:block; font-size:10px; font-weight:600; color:#94a3b8;
  text-transform:uppercase; letter-spacing:0.5px; margin-bottom:3px;
}
.pos-field input {
  width:100%; padding:6px 20px 6px 8px; border:1px solid #e2e8f0; border-radius:4px;
  font-size:13px; font-family:'JetBrains Mono',monospace; color:#1e293b;
  background:#f8fafc;
}
.pos-field input:focus { outline:none; border-color:#7abee0; background:#fff; }
.unit {
  position:absolute; right:6px; bottom:7px;
  font-size:10px; color:#94a3b8; pointer-events:none;
}

.presets { display:flex; gap:4px; }
.presets button {
  padding:3px 8px; border:1px solid #e2e8f0; border-radius:3px;
  background:#fff; font-size:10px; color:#64748b; cursor:pointer; font-family:inherit;
  transition:all 0.15s;
}
.presets button:hover { background:#f1f5f9; border-color:#cbd5e1; }
</style>
